import React from 'react';
import './styles/banner_style.css'; // CSS 파일 임포트

const BasicBanner = () => {
  return (
    <div className="banner"></div> // 배너로 사용될 div
  );
};

export default BasicBanner;
